<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="90" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                label="TIME"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                label="DATE"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row gutter>
            <mu-col width="50" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                data-vv-validate-on="none"
                data-vv-rules="required|min_value:30|max_value:300"
                data-vv-name="systolic"
                data-vv-as="Systolic"
                data-vv-value-path="inputValue"
                :errorText="errors.first('systolic')"
                type="number"
                :label="$t('message.labelSystolic')"
                v-model.number="reading.systolic"
                fullWidth></mu-text-field>
            </mu-col>
            <mu-col width="50" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                data-vv-validate-on="none"
                data-vv-rules="required|min_value:30|max_value:300"
                data-vv-name="diastolic"
                data-vv-as="Diastolic"
                data-vv-value-path="inputValue"
                :errorText="errors.first('diastolic')"
                type="number"
                :label="$t('message.labelDiastolic')"
                v-model.number="reading.diastolic"
                fullWidth
              ></mu-text-field>
            </mu-col>
          </mu-row>
          <!--<mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                data-vv-validate-on="none"
                data-vv-rules="min_value:0|max_value:220"
                data-vv-name="pulse"
                data-vv-as="Pulse"
                data-vv-value-path="inputValue"
                :errorText="errors.first('pulse')"
                type="number"
                label="Pulse"
                helpText="BPM"
                hintText="Enter"
                v-model.number="reading.pulse"
                fullWidth
              ></mu-text-field>
            </mu-col>
          </mu-row>-->
        </mu-col>
      </mu-row>
    </div>
    <button type="submit" style="display: none"></button>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <mu-raised-button
      @click.native="submitForm()"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>




  import BloodPressureApi from '../../../../api/Tracking/BloodPressure'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'


  export default {
    mixins: [TrackingEditMixin],
    name: 'bp-edit',
    props: {
      item: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isUpdating: false,
        reading: {}
      }
    },
    mounted() {
      let self = this;
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid) {
            self.isUpdating = true;
            BloodPressureApi.putBloodPressureTracking(self.reading)
              .then(function (response) {
                let offset = new Date();
                self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes')
                self.$emit('updateReading', self.reading);
                self.$emit('closeEditPanel');
                self.isUpdating = false;
              });
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BloodPressureEdit.vue?300ac526